import { ApiRequest, RequestMethod } from "../../request";

export async function addProfile(
  fighterId: string,
  fighterWeaponId: string,
  profileId: string,
  purchaseWithCredits: boolean
): Promise<boolean> {
  const URL = `/api/fighter/${fighterId}/fighter-weapon/add-profile`;
  const apiRequest = new ApiRequest();

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    fighterWeaponId: fighterWeaponId,
    profileId: profileId,
    purchaseWithCredits: purchaseWithCredits,
  });

  const response: any = await apiRequest.send();

  return response.status === 200;
}
